<template>
  <section class="row">
    <div class="col-12">
      <div class="card shadow">
        <div
          class="card-body px-md-4 py-md-5 rounded-4 py-4 transition-shadow
            box-shadow-green-300 box-shadow-hover-green-300"
        >
          <div class="row">
            <div class="col-1 pe-0">
              <v-icon
                icon="chevron-left"
                class="cursor-pointer"
                @click="() => $router.back()"
              />
            </div>
            <div class="col-10">
              <div class="h5 text-center mb-3">
                Nouvel utilisateur
              </div>
            </div>
            <div class="col-12 col-md-10 mx-auto">
              <p>
                Vous pouvez ajouter ici une personne qui pourra accéder à votre compte.
              </p>
            </div>
            <div class="col-12 col-md-10 mx-auto">
              <div class="row">
                <div class="col-12 col-md-6">
                  <v-input
                    label="Prénom"
                    placeholder="Nicolas"
                    value="firstName"
                    action-module="client"
                    path="newUser.firstName"
                  />
                </div>
                <div class="col-12 col-md-6 mt-3 mt-md-0">
                  <v-input
                    label="Nom"
                    placeholder="Moreau"
                    value="lastName"
                    action-module="client"
                    path="newUser.lastName"
                  />
                </div>
                <div class="col-12 my-3">
                  <v-select
                    input-id="position"
                    label="Fonction"
                    placeholder="Gérant"
                    module-name="client"
                    getter-name="position"
                    :input-validation="() => null"
                    path="newUser.position"
                    :list="positions"
                  />
                </div>
                <div class="col-12">
                  <v-input
                    label="Adresse email"
                    placeholder="nicolas.moreau@gmail.com"
                    value="email"
                    action-module="client"
                    path="newUser.email"
                    :validation="validateEmail"
                  />
                </div>
                <transition
                  @enter="tf_slideDown"
                  @leave="tf_slideUp"
                >
                  <div
                    v-if="error !== null"
                    class="col-12 text-danger mb-3"
                  >
                    {{ error }}
                  </div>
                </transition>
                <div class="col-12 mt-4">
                  <v-loader
                    :next="addMember"
                    :disable-button="isButtonDisabled"
                    title="Ajouter un nouveau utilisateur"
                    class="my-3 w-100"
                  />
                  <button
                    type="button"
                    class="btn btn-block w-100"
                    @click="() => $router.back()"
                  >
                    Annuler
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';
import { transform, routing, ui } from '@/mixins';
import { Input } from '@/components/common/input';
import CustomSelect from '@/components/common/input/CustomSelect2.vue';
import { validateEmail, validateDefault } from '@/utils/validators';

export default {
  name: 'AccoutAddMember',
  components: {
    'v-input': Input,
    'v-select': CustomSelect,
  },
  mixins: [transform, routing, ui],
  data() {
    return {
      validateEmail,
      validateDefault,
      error: null,
    };
  },
  computed: {
    ...mapGetters({
      positions: 'rater/positions',
      companyId: 'company/companyId',
    }),
    client() {
      return this.$store.getters['client/newUser'];
    },
    email() {
      return this.client.email || '';
    },
    lastName() {
      return this.client.lastName || '';
    },
    firstName() {
      return this.client.firstName || '';
    },
    position() {
      return this.client.position || { code: 'MANAGER', label: 'Gérant' };
    },
    isButtonDisabled() {
      return !this.validateEmail(this.client.email)
      || !this.validateDefault(this.client.lastName)
      || !this.validateDefault(this.client.firstName);
    },
  },
  methods: {
    async addMember() {
      try {
        await this.$store.dispatch('client/addMember');
        this.ui_accountModal({ type: 'newMember', value: true });
        this.$emit('show', false);
        await this.$store.dispatch('client/getMembers');
        return Promise.resolve();
      } catch (err) {
        this.error = 'Erreur, veuillez réessayer ultérieurement.';
        return Promise.reject();
      }
    },
  },
};
</script>
